<template>
  <div class="article-detail">
    <div class="detail-wrap">
      <div class="article">
        <div v-if="!hiddenTitle" class="article-top">
          <h2>{{ article.title }}</h2>
          <div class="article-info">
            <div>时间：{{ article.publishDate }}</div>
            <div>访问量：{{ readCount }}</div>
            <div v-if="catalogAlisa == 'dhjh1'">作者：{{ article.author }}</div>
          </div>
        </div>

        <div
          v-if="
            loadFinished && catalogAlisa !== 'lshtp' && catalogAlisa !== 'jlhtp'
          "
          class="article-content"
        >
          <div
            class="img"
            v-if="
              article.logo &&
              catalogAlisa !== 'spdt' &&
              catalogAlisa !== 'ndbg' &&
              catalogAlisa !== 'bndbg' &&
              catalogAlisa !== 'jdbg' &&
              catalogAlisa !== 'djzl' &&
              catalogAlisa !== 'djzl1' &&
              catalogAlisa !== 'gxzz' &&
              catalogAlisa !== 'spdt' &&
              catalogAlisa !== 'wzgg' &&
              catalogAlisa !== 'gydt' &&
              catalogAlisa !== 'xwdt' &&
              catalogAlisa !== 'xwzx' &&
              catalogAlisa !== 'dsdh' &&
              catalogAlisa !== 'dhjh1'
            "
          >
            <a :href="article.redirectUrl">
              <img
                :src="article.logo"
                alt=""
                style="width: 100%"
              />
            </a>
          </div>
          <div v-if="pdfLink">
            <iframe
              :src="pdfLink"
              width="100%"
              height="800px"
              frameborder="0"
            ></iframe>
          </div>
          <div
            v-else-if="shouldShowAttachmentPreview"
            class="article-inline-images"
          >
            <el-image
              v-for="file in previewImageList"
              :key="file.imageId || file.src"
              :src="file.src"
              :preview-src-list="previewImageSrcList"
              fit="contain"
              class="article-inline-image"
            />
          </div>
          <div v-else v-html="article.contentHtml"></div>
          <div
            class="img"
            v-if="catalogAlisa == 'dhjh1' && article.contentHtml == ''"
          >
            <img
              :src="article.logo"
              alt=""
              style="width: 100%"
            />
          </div>

          <div v-if="attachmentList.length" class="article-attachments">
            <div class="article-attachments__title">相关附件</div>
            <div
              v-for="file in attachmentList"
              :key="file.imageId || file.src"
              class="article-attachments__item"
            >
              <div class="article-attachments__name">
                {{ file.fileName || file.title || "附件" }}
              </div>
              <div class="article-attachments__actions">
                <el-button type="text" @click="handlePreviewAttachment(file)">
                  查看
                </el-button>
                <el-button type="text" @click="handleDownloadAttachment(file)">
                  下载
                </el-button>
              </div>
            </div>
          </div>

          <!-- <video v-if="catalogAlisa == 'spdt'" ref="videoPlayer" class="video-js"></video> -->
          <video
            v-if="catalogAlisa == 'spdt'"
            :src="src"
            controls
            class="video-js"
          ></video>
          <!-- <UiEmpty v-if="loadError" type="error" />
          <UiEmpty v-else-if="!pdfLink && !article.contentHtml" /> -->
        </div>

        <div v-else-if="catalogAlisa == 'lshtp'">
          <div
            class="img"
            style="display: flex; align-items: center; justify-content: center"
          >
            <img
              :src="article.logo"
              alt=""
              style="width: 16vw"
              class="personimg"
            />
          </div>
          <div
            v-html="article.exModelContent.zyzw"
            style="color: #5b2400; margin-top: 10px; font-size: 1vw"
            class="personContent"
          ></div>
          <div
            v-html="article.exModelContent.qtzw"
            style="color: #5b2400; margin-top: 10px; font-size: 1vw"
            class="personContent"
          ></div>
          <div
            v-html="article.contentHtml"
            style="color: #5b2400; margin-top: 10px; font-size: 1vw"
            class="personContent"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  cmsCatalogContentData,
  cmsStatContentVisit,
  cmsStatContentVisitCount,
  xwzxList,
  xwdtList,
} from "@/api/index";
import { downloadFile, getFileName, isPdf } from "@/utils/file";
import dayjs from "dayjs";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "Index",
  props: {
    catalogAlisa: {
      type: [String, Number],
      default: "",
    },
    articleId: {
      type: [String, Number],
      default: "",
    },
    hiddenTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pdfLink: "",
      article: {
        title: "",
        publishDate: "",
        contentHtml: "",
      },
      loadFinished: false,
      loadError: false,
      readCount: "--",
      player: null,
      src: "",
      EnglishIf: false,
    };
  },
  computed: {
    attachmentList() {
      return (this.article.imageList || []).filter((file) => file?.src);
    },
    previewImageList() {
      return this.attachmentList.filter((file) => this.isImageAttachment(file));
    },
    previewImageSrcList() {
      return this.previewImageList.map((file) => file.src);
    },
    shouldShowAttachmentPreview() {
      return (
        !this.pdfLink &&
        !this.article.contentHtml &&
        this.previewImageList.length > 0
      );
    },
  },
  mounted() {
    if (this.articleId) {
      this.getData(this.articleId);
    }

    if (localStorage.getItem("EnglishIf")) {
      this.EnglishIf =
        localStorage.getItem("EnglishIf") == "true" ? true : false;
    }
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "EnglishIf") {
        that.EnglishIf = JSON.parse(e.newValue);
      }
    });
  },
  methods: {
    getData(id) {
      if (this.$route.query.pdfLink) {
        this.pdfLink =
          "/pdfjs/web/viewer.html?file=" +
          encodeURIComponent(this.$route.query.pdfLink);
      }
      if (this.catalogAlisa == "xwdt") {
        console.log(this.$route.query.id);
        xwdtList().then((res) => {
          res.data.res.cmsContentList.forEach((v) => {
            if (v.id == this.$route.query.id) {
              this.article = v;
              this.article.publishDate = dayjs(Number(v.publishDate)).format("YYYY-MM-DD");
              this.loadFinished = true;
            }
          });
        });
      } else if (this.catalogAlisa == "xwzx") {
        console.log(this.$route.query.id);
        xwzxList().then((res) => {
          res.data.res.cmsContentList.forEach((v) => {
            if (v.id == this.$route.query.id) {
              this.article = v;
              this.article.publishDate = dayjs(Number(v.publishDate)).format("YYYY-MM-DD");
              this.loadFinished = true;
            }
          });
        });
      } else {
        cmsCatalogContentData(this.catalogAlisa, id)
          .then((res) => {
            if (res) {
              const { exModelContent, publishDate } = res;

              if (
                !this.pdfLink &&
                exModelContent &&
                isPdf(exModelContent.downloadLink)
              ) {
                this.pdfLink = exModelContent.downloadLink;
              }
              res.publishDate = dayjs(Number(publishDate)).format("YYYY-MM-DD");

              this.article = res;
              // if(this.article.redirectUrl) {
              //   window.location.href = this.article.redirectUrl
              // }
              this.getReadCount(res);
              this.toVisit(res);
              this.src = res.videoList[0].src;
              if (this.catalogAlisa == "spdt") {
                const videoEl = this.$refs.videoPlayer;
                this.player = videojs(
                  videoEl,
                  this.options,
                  function onPlayerReady() {
                    console.log("video.js 播放器已经准备好");
                  },
                );
                this.player.src({
                  type: "video/mp4",
                  src: res.videoList[0].src,
                });
                this.player.play();
              }
            }
          })
          .catch(() => {
            this.loadError = false;
          })
          .finally(() => {
            this.loadFinished = true;
          });
      }
    },
    toVisit({ contentId, catalogId }) {
      cmsStatContentVisit({ contentId, catalogId });
    },
    getReadCount({ contentId, catalogId }) {
      cmsStatContentVisitCount({ contentId, catalogId }).then((res) => {
        this.readCount = res.data;
      });
    },
    isImageAttachment(file) {
      const fileName = `${file?.fileName || file?.title || file?.src || ""}`.toLowerCase();
      return /(\.png|\.jpe?g|\.gif|\.webp|\.bmp|\.svg)$/.test(fileName);
    },
    handlePreviewAttachment(file) {
      if (!file?.src) {
        return;
      }

      if (isPdf(file.fileName || file.src)) {
        window.open(`/pdfjs/web/viewer.html?file=${file.src}`, "_blank");
        return;
      }

      window.open(file.src, "_blank");
    },
    async handleDownloadAttachment(file) {
      if (!file?.src) {
        return;
      }

      try {
        await downloadFile(
          file.src,
          file.fileName ||
            getFileName(file.src, file.title || this.article.title || "附件"),
        );
      } catch (error) {
        this.$message.warning("文件下载失败，请稍后重试");
      }
    },
  },
  beforeDestroy() {
    // 销毁video.js播放器
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style>
@media screen and (max-width: 768px) {
  .article-top > h2 {
    font-size: 18px !important;
  }
  .img {
    padding-right: 0% !important;
  }
  .personimg {
    width: 12rem !important;
  }
  .personContent {
    font-size: 1rem !important;
  }
}
</style>
<style scoped lang="less">
.video-js {
  width: 100%;
  height: 43vh;
  margin-bottom: 4vh;
}
.img {
  margin-left: 20%;
  padding-right: 20%;
}
.detail-wrap {
  padding: 20px 0;
}
.breadcrumb-wrap {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: rgb(91, 36, 0) solid 1.5px;
}
.article {
  .article-top {
    margin-bottom: 20px;
    text-align: center;
    color: #5b2400;
    padding-bottom: 40px;
    border-bottom: 1px solid #ddd;
  }
  .article-info {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    color: grey;
    > div {
      margin: 0 10px;
    }
  }
  .article-content p {
    margin-bottom: 1em;
    text-indent: 2em;
  }
  .article-attachments {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e5e5e5;
  }
  .article-inline-images {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  .article-inline-image {
    width: 100%;
    border-radius: 0.75rem;
    overflow: hidden;
    background: #faf7f3;
  }
  .article-attachments__title {
    margin-bottom: 1rem;
    color: #5b2400;
    font-size: 1.2rem;
    font-weight: 700;
  }
  .article-attachments__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.85rem 0;
    border-bottom: 1px solid #f0ece9;
    gap: 1rem;
  }
  .article-attachments__name {
    flex: 1;
    color: #5b2400;
    word-break: break-all;
  }
  .article-attachments__actions {
    flex-shrink: 0;
  }
  .no-content {
    text-align: center;
    color: grey;
  }
  &::v-deep {
    img {
      max-width: 100% !important;
      height: auto !important;
    }
    // p {
    //   word-wrap: break-word !important;
    //   font-size: inherit !important;
    // }
    // span {
    //   font-size: inherit !important;
    // }
  }
}

@media screen and (max-width: 768px) {
  .article .article-attachments__item {
    display: block;
  }

  .article .article-attachments__actions {
    margin-top: 0.5rem;
  }
}
</style>
